import { findElementAll, selectElement } from "../utils/element-handlers.utils";
import { popupLocalTimerState } from "../utils/popup.utils";

interface PopupObject {
    getHTMLElement: () => HTMLElement;
    isActiveOnInit: () => boolean;
    getTriggerName: () => string | null;
}

export default function initPopupComponent() {
    selectElement('div.n-popups', popupsElement => {
        const popupElements = findElementAll('div.n-popup', popupsElement);
        const popupInstances: PopupObject[] = [];
        const activePopupInstances: PopupObject[] = [];

        popupElements.forEach(setPopupInstance);

        popupsElement.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            closeCurrentActivePopup();
        });

        function setPopupInstance(
            popupElement: HTMLElement,
            index: number
        ) {
            const popupInstance = createPopupInstance(popupElement, index);

            popupInstances.push(popupInstance);
    
            if (popupInstance.isActiveOnInit()) {
                activePopupInstances.push(popupInstance);
            }
        }

        function createPopupInstance(
            popupElement: HTMLElement,
            index: number
        ) {
            const closeButton = popupElement.querySelector('button.n-popup-close-btn');
            const triggerName = popupElement.getAttribute('data-trigger') || null;
            const popupTimer = popupElement.getAttribute('data-popup-timer');
            const popupId = popupElement.getAttribute('id') || popupElement.getAttribute('data-id');

            popupElement.addEventListener('click', event => event.stopPropagation());
            
            let activeOnInit = popupElement.hasAttribute('data-popup-init');
        
            if (activeOnInit && popupTimer && popupId) {
                activeOnInit = popupLocalTimerState(popupId, popupTimer);
            }
        
            if (closeButton) {
                closeButton.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    setInactivePopup(index);
                    renderPopups();
                });
            }
        
            const popupInstanceActions: PopupObject = {
                getHTMLElement: function () {
                    return popupElement;
                },
                isActiveOnInit: function () {
                    return activeOnInit;
                },
                getTriggerName: function () {
                    return triggerName;
                }
            };
        
            return popupInstanceActions;
        }

        renderPopups();
        initTriggers();
    
        function renderPopups() {
            const popupInstanceToActivate = getPopupInstanceReady();

            if (popupInstanceToActivate) {
                showPopupsGroup();

                popupInstances.forEach(function (popupInstance) {
                    if (popupInstance === popupInstanceToActivate) {
                        showPopup(popupInstance);
                    }
                    else {
                        hidePopup(popupInstance);
                    }
                });
            }
            else {
                popupInstances.forEach(function (popupInstance) {
                    hidePopup(popupInstance);
                });

                setTimeout(hidePopupsGroup, 300);
            }

            function showPopupsGroup() {
                document.querySelector('html')!.classList.add('n-popups-active');
                document.body.classList.add('n-popups-active');
                popupsElement.classList.add('n-active');
                setTimeout(() => popupsElement.classList.add('n-ready'), 0);
            }

            function hidePopupsGroup() {
                popupsElement.classList.remove('n-ready');
                setTimeout(() => popupsElement.classList.remove('n-active'), 300);
                document.body.classList.remove('n-popups-active');
                document.querySelector('html')!.classList.remove('n-popups-active');
            }

            function showPopup(popupObject: PopupObject) {
                const popupElement = popupObject.getHTMLElement();
                popupElement.classList.add('n-active');
                setTimeout(() => popupElement.classList.add('n-ready'), 0);
            }

            function hidePopup(popupObject: PopupObject) {
                const popupElement = popupObject.getHTMLElement();
                popupElement.classList.add('n-closing');

                setTimeout(() => {
                    popupElement.classList.add('n-disappear');
                }, 0);

                setTimeout(() => {
                    popupElement.classList.remove('n-active');
                    popupElement.classList.remove('n-ready');
                    popupElement.classList.remove('n-closing');
                    popupElement.classList.remove('n-disappear');
                }, 300);
            }
        }

        function getPopupInstanceIndexReady(): number | null {
            const indexToActivate = activePopupInstances.length - 1;
            return indexToActivate > -1 ? indexToActivate : null;
        }

        function getPopupInstanceReady(): PopupObject | null {
            const indexToActivate = getPopupInstanceIndexReady();
            return indexToActivate !== null
                ? activePopupInstances[indexToActivate]
                : indexToActivate;
        }
    
        function setActivePopup(index: number) {
            var popupToSetActive = popupInstances[index];
    
            if (popupToSetActive && (activePopupInstances.indexOf(popupToSetActive) === -1)) {
                activePopupInstances.push(popupToSetActive);
            }
        }
        
        function setInactivePopup(index: number) {
            const popupToSetInactive = popupInstances[index];
            const activePopupIndex = activePopupInstances.indexOf(popupToSetInactive);
    
            if (popupToSetInactive && (activePopupIndex > -1)) {
                activePopupInstances.splice(activePopupIndex, 1);
            }
        }
    
        function getPopupIndexesByTriggerName(triggerName: string) {
            var result: number[] = [];
    
            popupInstances.forEach(function (popupInstance, index) {
                if (popupInstance.getTriggerName() === triggerName) {
                    result.push(index);
                }
            });
    
            return result;
        }
    
        function initTriggers() {
            $(document).on('click', '[data-popup-trigger]', function (event) {
                var triggerName = this.getAttribute('data-popup-trigger');
    
                if (triggerName) {
                    var indexesToActivate = getPopupIndexesByTriggerName(triggerName);
    
                    if (indexesToActivate.length) {
                        indexesToActivate.forEach(setActivePopup);
                        renderPopups();
                    }
                }
            });
        }

        function closeCurrentActivePopup() {
            const indexToDeactivate = getPopupInstanceIndexReady();

            if (indexToDeactivate !== null) {
                setInactivePopup(indexToDeactivate);
                renderPopups();
            }
        }
    });
}
